
import { Routes, Route } from "react-router-dom";
import { AuthProvider, useAuth } from "@/components/admin/AuthProvider";
import SecureAdminAuth from "@/components/admin/SecureAdminAuth";
import { AdminLayout } from "@/components/admin/layout/AdminLayout";
import { AdminDashboard } from "@/components/admin/dashboard/AdminDashboard";
import DealsPage from "@/components/admin/deals/DealsPage";
import { InvestmentsPage } from "@/components/admin/investments/InvestmentsPage";
import { QuotesPage } from "@/components/admin/quotes/QuotesPage";
import { CallsPage } from "@/components/admin/calls/CallsPage";
import { CalculatorPage } from "@/components/admin/calculator/CalculatorPage";
import { AmortizationPage } from "@/components/admin/amortization/AmortizationPage";
import { ContactsPage } from "@/components/admin/contacts/ContactsPage";
import { AgreementsPage } from "../components/admin/agreements/AgreementsPage";

function AdminPortalContent() {
  const { user, isAdmin, isLoading, signOut } = useAuth();
  
  console.log('🔐 AdminPortal VERSION 2.0 with NEW SIDEBAR loaded');
  console.log('👤 Auth state:', { user: !!user, isAdmin, isLoading });

  if (isLoading) {
    return (
      <div className="min-h-screen bg-gradient-to-br from-slate-50 to-blue-50 flex items-center justify-center">
        <div className="text-lg">Loading...</div>
      </div>
    );
  }

  if (!user || !isAdmin) {
    return <SecureAdminAuth />;
  }

  return (
    <AdminLayout onSignOut={signOut}>
      <Routes>
        <Route path="/" element={<AdminDashboard />} />
        <Route path="/deals" element={<DealsPage />} />
        <Route path="/investments" element={<InvestmentsPage />} />
        <Route path="/quotes" element={<QuotesPage />} />
        <Route path="/agreements" element={<AgreementsPage />} />
        <Route path="/calls" element={<CallsPage />} />
        <Route path="/calculator" element={<CalculatorPage />} />
        <Route path="/amortization" element={<AmortizationPage />} />
        <Route path="/contacts" element={<ContactsPage />} />
      </Routes>
    </AdminLayout>
  );
}

const AdminPortal = () => {
  return (
    <AuthProvider>
      <AdminPortalContent />
    </AuthProvider>
  );
};

export default AdminPortal;
